import mapFunction from './mapResources';

export default mapFunction('building_issue_records', {
    isFetching: false,
    items: []
});